




import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";

@Component({
  extends: BaseView
})
export default class LogoutView extends Vue {
  mounted() {
    this.$store.dispatch("User/logout").then(() => this.$router.push("/login"));
  }
}
